import React, { Component, Fragment } from "react";
import { IsAuthorize } from "../../../../../../shared/authorization/check-access";
import { Role } from "../../../../../../shared/authorization/enums";
import { NavLink } from "react-router-dom";

interface IProps {
  id: number;
  url: string;
  name?: string;
}
export class ExtractorSemaphoresTabs extends Component<IProps> {
  render() {
    return (
      <Fragment>
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          {IsAuthorize([Role.Dev]) && (
            <li className="nav-item">
              <NavLink
                to={"/extractor-semaphore/extractor-semaphore-form/" + this.props.id}
                className={
                  this.props.url === "/extractor-semaphore/extractor-semaphore-form/"
                    ? "nav-link active"
                    : "nav-link"
                }
                id="edit-tab"
                data-toggle="tab"
                href="#edit"
                role="tab"
                aria-controls="edit"
                aria-selected={
                  this.props.url === "/extractor-semaphore/extractor-semaphore-form/"
                    ? "true"
                    : "false"
                }
              >
                <i className="far fa-edit"></i>&nbsp;Edit
              </NavLink>
            </li>
          )}
          {IsAuthorize([Role.Dev]) && (
            <li className="nav-item">
              <NavLink
                to={
                  "/extractor-semaphore/delete/" + this.props.id
                }
                className={
                  this.props.url === "/extractor-semaphore/delete/"
                    ? "nav-link active"
                    : "nav-link"
                }
                id="show-tab"
                data-toggle="tab"
                href="#delete"
                role="tab"
                aria-controls="delete"
                aria-selected={
                  this.props.url === "/extractor-semaphore/delete/" ? "true" : "false"
                }
              >
                <i className="far fa-trash-alt"></i>&nbsp;Delete
              </NavLink>
            </li>
          )}
          {IsAuthorize([Role.TAM, Role.Dev, Role.Support]) && (
            <li className="nav-item">
              <NavLink
                to={"/extractor-semaphore/detail/" + this.props.id}
                className={
                  this.props.url === "/extractor-semaphore/detail/"
                    ? "nav-link active"
                    : "nav-link"
                }
                id="show-tab"
                data-toggle="tab"
                href="#show"
                role="tab"
                aria-controls="show"
                aria-selected={
                  this.props.url === "/extractor-semaphore/detail/" ? "true" : "false"
                }
              >
                <i className="fas fa-info-circle"></i>&nbsp;Show
              </NavLink>
            </li>
          )}
        </ul>
        <br />
      </Fragment>
    );
  }
}
